import React from 'react';

const ChartSkill = (props) => (
    <div className="skill">
        <div className="skill-title">
            <span className="skill-name">{props.name}</span>
            {/* <i className="fa fa-info-circle" aria-hidden="true"></i> */}
            <span  className="skill-value">{props.value}%</span>
        </div>
        <div className="progress">
            <div className="progress-bar progress3" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: props.value + "%"}}>
            </div>
        </div>
    </div>
);

export default ChartSkill;


// WEBPACK FOOTER //
// ./src/components/skills/Charts/skill.js